import { RoutesApi } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class RouteService {
  private readonly httpClient = createApiClient(RoutesApi)

  async getTruckVisitRoute(visitId: number, entryGateId: string, exitGateId: string) {
    const { data } = await this.httpClient.truckVisitRoute(visitId, entryGateId, exitGateId)
    return data
  }
}

export const routeService = new RouteService()
